var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("EmulatorSectionHeader", { attrs: { title: "Styles" } }),
      _c("h6", { staticClass: "header-pretitle mb-3" }, [_vm._v("Mode")]),
      _c(
        "div",
        { staticClass: "btn-group-toggle row gx-2 mb-4" },
        _vm._l(_vm.themeStyleModes, function (mode) {
          return _c("div", { key: mode.key, staticClass: "col" }, [
            _c(
              "label",
              {
                staticClass: "btn w-100 btn-white",
                class: { active: mode.key === _vm.activeModeKey },
                on: {
                  click: function ($event) {
                    return _vm.setActiveMode(mode.key)
                  },
                },
              },
              [_vm._v(" " + _vm._s(mode.title) + " ")]
            ),
          ])
        }),
        0
      ),
      _vm._l(_vm.activeModeGroups, function (group) {
        return _c(
          "div",
          { key: group.category },
          [
            _c("h4", { staticClass: "mt-4 mb-3" }, [
              _vm._v(_vm._s(group.category)),
            ]),
            _vm._l(group.styles, function (style) {
              return _c("EmulatorCustomizationTextBox", {
                key: style.path,
                attrs: {
                  category: _vm.activeMode.title + " - " + style.category,
                  label: style.label,
                  namespace: "theme",
                  path: style.path,
                  dataType: style.dataType,
                  placeholder: _vm.placeholderForStyle(style),
                  validator: _vm.validatorForStyle(style),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var value = ref.value
                        return [
                          style.dataType === "color"
                            ? _c(
                                "div",
                                { staticClass: "col-auto" },
                                [
                                  _c("ColorSwatch", {
                                    attrs: { color: value },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
          ],
          2
        )
      }),
      _vm.customCssEnabled
        ? _c("EmulatorCustomizationTextBox", {
            attrs: {
              category: "Custom Styles",
              label: "Custom CSS",
              namespace: "theme",
              path: "customCSS",
              dataType: "string",
              inputType: "textarea",
              placeholder: "Paste or type your CSS here",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "postInput",
                  fn: function () {
                    return [
                      _c(
                        "Alert",
                        { staticClass: "mb-4", attrs: { type: "warning" } },
                        [
                          _c("p", [
                            _vm._v(
                              "We cannot guarantee your custom CSS will work as expected."
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              " Custom CSS cannot override certain content, including references to Atomic. Some references to Atomic will be automatically applied if you use this feature. "
                            ),
                          ]),
                          _c("p", { staticClass: "disclaimer" }, [
                            _vm._v(
                              " Disclaimer: Our support agreement does not include assistance with modifying or debugging your custom CSS. "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              490681734
            ),
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }